import Blaze from "@swiggy-private/blaze.js";
import { getGeneralizeUrl } from "./api";

const eventType = "influencer_web";

export const sendCustomNREvViaBlaze = (
    type: string,
    body: Record<string, string | number>,
    headers: Record<string, string | undefined> | void,
) => {
    Blaze.recordCustomEvent({
        eventType: eventType,
        type,
        referrer: window.location.href,
        ...body,
        ...headers,
    });
};

export const sendNRApiEventsViaBlaze = (
    type: string,
    body: Record<string, string | number>,
    headers: Record<string, string | undefined> | void,
) => {
    const { url = "" } = body;
    const generalizedBody = { ...body, url: getGeneralizeUrl(String(url)) };
    Blaze.recordCustomEvent({
        eventType: eventType,
        type,
        referrer: window.location.href,
        ...generalizedBody,
        ...headers,
    });
};
